import ItemsList from "template-store/components/items-list/items-list-component";
import { useMemo, useCallback } from "react";

const IntegrationsComponent = ({ templateData, metadata, translate }) => {
  const { integrations } = templateData;

  const getIntegrationMetadata = useCallback(
    (integration) => {
      return metadata?.find((integrationMetadata) => integrationMetadata.value === integration);
    },
    [metadata]
  );

  const integrationsData = useMemo(() => {
    if (!integrations) return;

    return integrations.map((integration) => {
      const integrationMetada = getIntegrationMetadata(integration);
      if (!integrationMetada) return null;
      return {
        title: integrationMetada.text,
        description: translate(`templateCenter.integration.${integration}.description`),
        icon: integrationMetada.templateStoreUrl
      };
    });
  }, [getIntegrationMetadata, integrations, translate]);

  return integrations ? <ItemsList items={integrationsData} /> : null;
};

export default IntegrationsComponent;
